import { FeaturedVenueDto } from '@ivy-monorepo/shared'
import { apiClient } from './api-client'

class ContentService {
  async getTermsOfUse(): Promise<string> {
    const response = await apiClient.get('/content/pages/terms-of-use')
    return response.data.content
  }
  async getPrivacyPolicy(): Promise<string> {
    const response = await apiClient.get('/content/pages/privacy-policy')
    return response.data.content
  }
  async getFeaturedVenues(limit: number): Promise<FeaturedVenueDto[]> {
    const response = await apiClient.get<FeaturedVenueDto[]>('/content/venues/featured', { params: { limit } })
    return response.data
  }
}

export const contentService = new ContentService()
